import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import './MyBlockMonthPrintDialog.scss';

interface MyBlockMonthPrintDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  startPrinting: (orientation: string) => void;
}

const MyBlockMonthPrintDialog: React.FC<MyBlockMonthPrintDialogProps> = ({
  open,
  setOpen,
  startPrinting
}) => {
  const { t } = useTranslation();

  const handleDialogClose = (event, reason) => {
    reason !== 'backdropClick' && setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      className="myblockmonth-print-dialog"
      maxWidth="lg"
      disableEscapeKeyDown={true}
    >
      <CloseIcon className="close-btn" onClick={() => setOpen(false)} />
      <DialogTitle className="dialog-title">
        {t('myBlockMonth.printDialog.description')}
      </DialogTitle>
      <DialogActions>
        <div className="buttons">
          <Button
            className="btn-white"
            onClick={() => startPrinting('landscape')}
          >
            <span>{t('myBlockMonth.printDialog.landscape')}</span>
          </Button>
          <Button
            className="btn-white"
            onClick={() => startPrinting('portrait')}
          >
            ​​​ <span>{t('myBlockMonth.printDialog.portrait')}</span>
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default MyBlockMonthPrintDialog;
